import { Intent } from '../../@types/intent'
import { RealEstateType } from '../../@types/realEstateType'

export const redirectWithToggle = (intent: Intent, realEstateType?: RealEstateType) => {
  if (intent == Intent.INDEPENDENT_SALE) {
    switch (realEstateType) {
      case RealEstateType.HOUSE:
        window.open(
          'https://www.immobilienscout24.de/anbieten/anzeige-schalten/private-anbieter/eigentuemer/verkaufen/haus/?cmp_id=10-052203&cmp_name=ppa_insertion&cmp_position=homeowner_realtorleadengine_ibw&cmp_creative=ppa_integration_sell_short'
        )
        break
      case RealEstateType.APARTMENT:
        window.open(
          'https://www.immobilienscout24.de/anbieten/anzeige-schalten/private-anbieter/eigentuemer/verkaufen/wohnung/?cmp_id=10-052204&cmp_name=ppa_insertion&cmp_position=homeowner_realtorleadengine_ibw&cmp_creative=ppa_integration_sell_short'
        )
        break
      case RealEstateType.LAND:
        window.open(
          'https://www.immobilienscout24.de/anbieten/anzeige-schalten/private-anbieter/eigentuemer/verkaufen/grundstueck/?cmp_id=10-052205&cmp_name=ppa_insertion&cmp_position=homeowner_realtorleadengine_ibw&cmp_creative=ppa_integration_sell_short'
        )
        break
      case RealEstateType.COMMERCIAL:
        window.open(
          'https://www.immobilienscout24.de/scoutmanager/inserieren/app/index.html?cmp_id=10-052209&cmp_name=ppa_insertion&cmp_position=homeowner_realtorleadengine_ibw&cmp_creative=ppa_integration_let_short'
        )
        break
    }
  } else if (intent == Intent.BUY) {
    window.open(
      'https://www.immobilienscout24.de/baufinanzierung/finanzierungsangebote/?cmp_id=10-051998&cmp_name=finance_realtorleadengine_ibw&cmp_position=buy_successpage_ibw&cmp_creative=button'
    )
  } else if (intent == Intent.RENT) {
    window.open(
      'https://www.immobilienscout24.de/warenkorb/mieterplus?cmp_id=10-051999&cmp_name=premium_profil_rent&cmp_position=rent_successpage_ibw&cmp_creative=button_checkout'
    )
  } else if (intent == Intent.LET || intent == Intent.INDEPENDENT_LET) {
    switch (realEstateType) {
      case RealEstateType.HOUSE:
        window.open(
          'https://www.immobilienscout24.de/anbieten/anzeige-schalten/private-anbieter/eigentuemer/vermieten/haus/?cmp_id=10-052207&cmp_name=ppa_insertion&cmp_position=homeowner_realtorleadengine_ibw&cmp_creative=ppa_integration_let_short'
        )
        break
      case RealEstateType.APARTMENT:
        window.open(
          'https://www.immobilienscout24.de/anbieten/anzeige-schalten/private-anbieter/eigentuemer/vermieten/wohnung/?cmp_id=10-052208&cmp_name=ppa_insertion&cmp_position=homeowner_realtorleadengine_ibw&cmp_creative=ppa_integration_let_short'
        )
        break
      case RealEstateType.LAND:
        window.open(
          'https://www.immobilienscout24.de/scoutmanager/inserieren/app/index.html?cmp_id=10-052209&cmp_name=ppa_insertion&cmp_position=homeowner_realtorleadengine_ibw&cmp_creative=ppa_integration_let_short'
        )
        break
    }
  }
}
